import { ModalWrapper } from 'common/components/molecules/ModalWrapper';
import styled from 'styled-components';

export const StyledModal = styled(ModalWrapper)`
  position: relative;
  height: fit-content;
  width: 900px;
  max-height: 750px;
`;
